import { capitalizeEachFirstLetter } from '../../../../utils/format'
import { BadgeColors } from '../../../Badge/Badge.types'

export const getBadgeColor = (rating?: number) => {
  if (rating === undefined || rating === null) {
    return BadgeColors.neutral
  }

  switch (true) {
    case rating > 4:
      return BadgeColors.success
    case rating <= 4 && rating > 3:
      return BadgeColors.warning
    case rating <= 3 && rating >= 0:
      return BadgeColors.failure
    default:
      return BadgeColors.neutral
  }
}

export const cleanTagText = (tag: string) => {
  const cleanTag = tag
    .replace('GUEST_REVIEW_HOST', '')
    .replace('HOST_REVIEW_GUEST', '')
    .replace('NEGATIVE', '')
    .replace('OTHER', '')
    .replace('POSITIVE', '')
    .replace(/_/g, ' ')

  return capitalizeEachFirstLetter(cleanTag)
}
